import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../../Shared/PageTitle/PageTitle";
import SectionTitle from "../../Shared/SectionTitle";
import ProductItem from "./components/ProductItem";

const ProductList = ({
  data,
  title,
  link,
  currentPage,
  subTitle = "",
  route,
}) => {
  const [selectedItem, setSelectedItem] = useState({});
  // get the specified equipment
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(10, 0);
  }, []);

  useEffect(() => {
    // find the selected equipment
    const index = data.findIndex((eq) => eq.id.toString() === id);
    if (index !== -1) {
      setSelectedItem(data[index]);
    }
  }, [id]);

  return (
    <>
      <PageTitle
        title={title}
        currentPage={currentPage}
        link={link}
        category={selectedItem.title}
      />

      <section className="wpo-team-section section-padding">
        <div className="container">
          <SectionTitle MainTitle={selectedItem.title} subTitle={subTitle} />
          <div className="wpo-team-wrap">
            <div className="row product-list">
              {selectedItem.products &&
                selectedItem.products.map((product) => (
                  <ProductItem
                    key={product.id}
                    selectedItem={selectedItem}
                    product={product}
                    route={route}
                  />
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductList;
